import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MemberInsurerServiceService {
  private readonly USER_ROLE_KEY = 'userRole';
  private readonly USER_ROLE_ACCESS_KEY = 'userRoleAccess';
  private readonly IS_LOGGED_IN_KEY = 'isUserLoggedIn';
  private readonly USER_ID_KEY = 'userId';
  private readonly USER_PRIMARY_ID_KEY = 'userPrimaryId';
  private readonly USER_PRIMARY_EMAIL = 'userEmail';
  private readonly USER_INFO = 'userInfo';
  private readonly USER_ADMIN_ID_KEY = 'userAdminId';
  private readonly USER_ORG = 'userOrg';
  private readonly USER_NAME = 'userName';
  private readonly LOGIN_START_TIME = 'loginStartTime';
  private readonly CREATED_BY = 'createdby';

  private selectedPatientSource = new BehaviorSubject<any>(null);
  selectedPatient$ = this.selectedPatientSource.asObservable();

  private tabChangeSubject = new Subject<string>();
  tabChanged$ = this.tabChangeSubject.asObservable();

  private refreshDashboardProvider = new Subject<void>();
  refreshDashboard$ = this.refreshDashboardProvider.asObservable();

  private refreshAdminInsurer = new Subject<void>();
  refreshAdminInsurer$ = this.refreshAdminInsurer.asObservable();
  private refreshAdminDistributor = new Subject<void>();
  refreshAdminDistributor$ = this.refreshAdminDistributor.asObservable()

  private refreshInsurerOrg = new Subject<void>();
  refreshInsurerOrg$ = this.refreshInsurerOrg.asObservable();
   private refreshProviderOrg = new Subject<void>();
  refreshProviderOrg$ = this.refreshProviderOrg.asObservable();
   private readonly refreshDistributorOrg = new Subject<void>();
  refreshDistributorOrg$ = this.refreshDistributorOrg.asObservable();



  private refreshAdminProvider = new Subject<void>();
  refreshAdminProvider$ = this.refreshAdminProvider.asObservable();
  private refreshotp =new Subject<void>();
  refreshotp$=this.refreshotp.asObservable();

  private sideBarTabChangeSubject = new Subject<string>();
  sideBarTabChanged$ = this.sideBarTabChangeSubject.asObservable();

  private sidebarExpanded = new BehaviorSubject<boolean>(false); // default: expanded
  sidebarExpanded$ = this.sidebarExpanded.asObservable();

  private refreshAgents = new Subject<void>(); // default: expanded
  refreshAgents$ = this.refreshAgents.asObservable();

  private refreshProviders = new Subject<void>(); // default: expanded
  refreshProviders$ = this.refreshProviders.asObservable();

  setSidebarState(isExpanded: boolean) {
    this.sidebarExpanded.next(isExpanded);
  }

  setrefreshAgents() {
    this.refreshAgents.next();
  }

  setrefreshProviders() {
    this.refreshProviders.next();
  }

  sideBarchangeTab(tab: string): void {
    this.sideBarTabChangeSubject.next(tab);
  }

  emitRefresh() {
    this.refreshDashboardProvider.next();
  }

  emitrefreshotp(){
    console.log('method triggered succesfull')
    this.refreshotp.next();
  }

  emitRefreshAdminInsurer() {
    this.refreshAdminInsurer.next();
  }

  emitRefreshInsurerOrg(){
    this.refreshInsurerOrg.next()
  }
 emitRefreshProviderOrg(){
    this.refreshProviderOrg.next()
  }
   emitRefreshDistributorOrg(){
    this.refreshDistributorOrg.next()
  }
  emitRefreshAdminProvider() {
    this.refreshAdminProvider.next();
  }
  emitRefreshAdminDistributor() {
    this.refreshAdminDistributor.next();
  }

  changeTab(tab: string) {
    this.tabChangeSubject.next(tab);
  }

  setSelectedPatient(patient: any): void {
    this.selectedPatientSource.next(patient);
  }

  constructor() { }

  setLoginUserRole(role: string): void {
    sessionStorage.setItem(this.USER_ROLE_KEY, role);
  }

  getLoginUserRole(): string {
    return sessionStorage.getItem(this.USER_ROLE_KEY) || '';
  }

  setUserAccess(role: string): void {
    sessionStorage.setItem(this.USER_ROLE_ACCESS_KEY, role);
  }

  getUserAccess(): string {
    return sessionStorage.getItem(this.USER_ROLE_ACCESS_KEY) || '';
  }


  setLoginUserId(userId: string): void {
    sessionStorage.setItem(this.USER_ID_KEY, userId);
  }

  getLoginUserId(): string {
    return sessionStorage.getItem(this.USER_ID_KEY) || '';
  }


  setLoginUserPrimaryId(userId: string): void {
    sessionStorage.setItem(this.USER_PRIMARY_ID_KEY, userId);
  }

  setLoginUserInfo(info: any): void {
    sessionStorage.setItem(this.USER_INFO, JSON.stringify(info));
  }

  getLoginUserInfo(): any {
    const userInfo = sessionStorage.getItem(this.USER_INFO);
    try {
      return userInfo ? JSON.parse(userInfo) : {};
    } catch (error) {
      console.error('Error parsing user info from sessionStorage:', error);
      return {};
    }
  }


  setLoginUserEmail(email: string): void {
    sessionStorage.setItem(this.USER_PRIMARY_EMAIL, email);
  }

  getLoginUserPrimaryId(): string {
    return sessionStorage.getItem(this.USER_PRIMARY_ID_KEY) || '';
  }

  setLoginUserAdminId(userId: string): void {
    sessionStorage.setItem(this.USER_ADMIN_ID_KEY, userId);
  }

  getLoginUserAdminId(): string {
    return sessionStorage.getItem(this.USER_ADMIN_ID_KEY) || '';
  }
  setCreatedBy(createdby: string): void {
    sessionStorage.setItem(this.CREATED_BY, createdby)


  }
  getCreatedBy(): string {
    return sessionStorage.getItem(this.CREATED_BY) || '';
  }

  setOrg(userId: string): void {
    sessionStorage.setItem(this.USER_ORG, userId);
  }

  getOrg(): string {
    return sessionStorage.getItem(this.USER_ORG) || '';
  }


  setLoginUserName(userName: string): void {
    sessionStorage.setItem(this.USER_NAME, userName);
  }

  getLoginUserName(): string {
    return sessionStorage.getItem(this.USER_NAME) || '';
  }

  getLoginUserEmail(): string {
    return sessionStorage.getItem(this.USER_PRIMARY_EMAIL) || '';
  }

  clearLoginUserRole(): void {
    sessionStorage.removeItem(this.USER_ROLE_KEY);
    sessionStorage.removeItem(this.IS_LOGGED_IN_KEY); // Clear login status too
    sessionStorage.removeItem(this.USER_ID_KEY); // Clear login status too
    sessionStorage.removeItem(this.USER_ROLE_ACCESS_KEY); // Clear login status too
    sessionStorage.removeItem(this.LOGIN_START_TIME); // Clear login start time too
    sessionStorage.clear();
  }

  // ✅ Set login status
  setUserLoggedIn(status: boolean): void {
    sessionStorage.setItem(this.IS_LOGGED_IN_KEY, status ? 'true' : 'false');
  }

  // ✅ Get login status as string
  isUserLoggedIn(): string {
    return sessionStorage.getItem(this.IS_LOGGED_IN_KEY) || 'false';
  }

  // ✅ Set login start time
  setLoginStartTime(): void {
    sessionStorage.setItem(this.LOGIN_START_TIME, new Date().toISOString());
  }

  // ✅ Get login start time
  getLoginStartTime(): Date | null {
    const timeString = sessionStorage.getItem(this.LOGIN_START_TIME);
    return timeString ? new Date(timeString) : null;
  }
}
